import React, { FC } from 'react';
import TradeInSection from '../TradeInSection';
import { useSelector } from 'react-redux';
import partExchangeSelectors from '../../../../../store/selectors/partExchangeSelectors';
import { IPrice } from '../../../../../../../../common/model/IPrice';
import currentDealSelectors from '../../../../../store/selectors/currentDealSelectors';
import { usePersistedCurrencyPreference } from '../../../../../react/usePersistedCurrencyPreference';
import optionsSelectors from '../../../../../store/selectors/optionsSelectors';

const SummaryTradeIn: FC = ({}) => {
  const tradeInValue: number = useSelector(partExchangeSelectors.getPartExchangeValuation);
  const tradeInCar: string | undefined = useSelector(partExchangeSelectors.getPartExchangeTitle);
  const tradeInManufactureYear: number | undefined = useSelector(partExchangeSelectors.getPartExchangeManufactureYear);
  const totalAmountPayable: IPrice = useSelector(currentDealSelectors.getTotalAmountPayable);
  const primaryPrice: IPrice = useSelector(currentDealSelectors.getPrimaryPrice);
  const { isSecondaryCurrencyDisplay } = usePersistedCurrencyPreference();
  const secondaryPrice: IPrice = useSelector(currentDealSelectors.getSecondaryPrice);
  const optionsLoading = useSelector(optionsSelectors.getOptionsLoadingState);
  const isDealLoading = useSelector(currentDealSelectors.getLoadingStatus);
  const isReloading = isDealLoading || optionsLoading;
  const currency: string = isSecondaryCurrencyDisplay ? secondaryPrice?.currency : primaryPrice?.currency;

  return (
    <>
      {tradeInCar && (
        <TradeInSection
          loading={isReloading}
          tradeInValue={tradeInValue}
          tradeInCar={tradeInCar}
          tradeInManufactureYear={tradeInManufactureYear}
          currency={currency}
          totalAmountPayable={totalAmountPayable?.basePrice}
        />
      )}
    </>
  );
};

export default SummaryTradeIn;
